<template>
    <div class="h-screen w-full bg-black-800 fixed top-0 z-0 opacity-50">
    </div>
</template>

<script>
/**
 *  透明度0.8的黑色遮罩
 */
export default {
    name: 'BackgroundOverlay'
};
</script>